<bb-card-loading *ngIf="loading"></bb-card-loading>
<ng-container *ngIf="!!timecards">
    <ion-list>
        <ion-item *ngIf="timecards.length === 0">
            No timecards were started in this time period.
        </ion-item>
        <ion-item *ngFor="let timecard of timecards; trackBy: getId" class="pointer" (click)="editTimecard(timecard)">
            <ion-label>
                {{ timecard.person.name }}
                <p>{{timecard.clockInTime | date:'short'}}</p>
                <p *ngIf="!!timecard.pickupLocation">{{timecard.pickupLocation.name}}</p>
            </ion-label>
            <div class="ion-text-center" slot="end">
                {{formatTotalTime(timecard)}}
                <ion-text *ngIf="timecard.tipped" color="success">
                    <p>Tipped</p>
                </ion-text>
                <p *ngIf="!timecard.clockOutTime" class="active-label">Active</p>
            </div>
        </ion-item>
    </ion-list>

    <ion-item *ngIf="!loading && error">
        <ion-text color="danger">Could not load data.</ion-text>
    </ion-item>
</ng-container>
